<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-5">
      <legend class="usa-legend usa-legend--large">SIT Shipment Report Status</legend>
    </div>
    <div class="grid-col-7 padding-y-3">
      <button type="button" class="usa-button" (click)="onShipmentReportClicked()" >
        Comprehensive Report
      </button>
    </div>


  </div>

  <form id="iffdelindReportGroup" role="form" [formGroup]="iffDelinqReport" (ngSubmit)="getIFFDelinqReport()">
    <div class="grid-row grid-gap">

      @if (isRfsp) {
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="tsp_list" class="usa-label">TSP List<abbr title="required"
          class="usa-hint usa-hint--required">*</abbr></label>
          <select id="tsp_list" class="usa-select width-full" formControlName='tspListSelect' (change)="tspChange();">
            <option hidden value=''>Choose...</option>
            @for (selectedTsp of rfspScacList; track selectedTsp) {
              <option [value]="selectedTsp">
              {{selectedTsp}}</option>
            }
          </select>
        </div>
      }

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="reportingYrSelect" class="usa-label">Reporting Calender Year<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="reportingYrSelect" class="usa-select width-full" formControlName='reportingYrSelect' (change)="getDelinqEmailStatus();">
          <option hidden value=''>Choose...</option>
          @for (reportingYrSingle of reportingYrList; track reportingYrSingle) {
            <option [value]="reportingYrSingle">
            {{reportingYrSingle}}</option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="reportingQtrSelect" class="usa-label">Reporting Quarter<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="reportingQtrSelect" class="usa-select width-full" formControlName='reportingQtrSelect' (change)="getDelinqEmailStatus();">
          <option hidden value=''>Choose...</option>
          @for (qtr of this.printQtrList; track qtr) {
            <option [value]="qtr.value">{{qtr.name}}</option>
          }
        </select>
      </div>

    </div>
    <div class="grid-row grid-gap padding-top-2 padding-bottom-4">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <button type="button" class="usa-button" type="submit" [disabled]="this.iffDelinqReport.invalid">Search</button>
      </div>
    </div>
    @if (rowData && rowData.length>0) {
      <div class="grid-row grid-gap padding-bottom-205">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
        </div>
      </div>
    }
    <div>
      <ag-grid-angular class="ag-theme-alpine" [columnDefs]="columnsDefs" [gridOptions]="gridOptions" [rowData]="rowData" [suppressDragLeaveHidesColumns]="true" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </form>

</div>
